import React, { useEffect, useState } from 'react';
import { Box, Typography, Stack, Grid, IconButton, Chip, Paper, Divider, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getFormatedDate } from '../../utils/common';
import { getMilestonesPaymentStatus } from './campaign_by_influencer/action';
import { ROUTES } from '../../utils/routes';

const CampaignByInfluencerDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [campaign, setCampaign] = useState(null);
    const [milestones, setMilestones] = useState([]);

    useEffect(() => {
        if (id) {
            dispatch(getMilestonesPaymentStatus(id)).then((res) => {
                if (res && res.data && res.data.result) {
                    // Backend returns { result: { milestones: [], campaign: {} } }
                    if (res.data.result.milestones) setMilestones(res.data.result.milestones);
                    if (res.data.result.campaign) setCampaign(res.data.result.campaign);
                }
            });
        }
    }, [id, dispatch]);

    const handlePayment = (link) => {
        if (link) window.open(link, '_blank');
    };

    const totalPaid = milestones
        .filter(m => m.paymentStatus === 'completed')
        .reduce((sum, m) => sum + parseFloat(m.amount || 0), 0);

    return (
        <Box sx={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #c3e6ec 0%, #eaddf9 100%)', // Matches the soft blue-purple gradient
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            p: 2
        }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexGrow: 1,
                    maxWidth: '856px',
                    // border: 2px solid;
                    // border-image-source: linear-gradient(92.31deg, #FFCC70 -21.87%, #C850C0 41.76%, #4158D0 104.13%);
                    padding: '2px',
                    background: "linear-gradient(92.31deg, #FFCC70 -21.87%, #C850C0 41.76%, #4158D0 104.13%)",
                    position: 'relative',
                    borderRadius: '16px',
                    boxShadow: '0px 0px 24px 0px #0000001A',

                }}
                lg={{
                    minWidth: '856px',
                }}
            >

                <Paper elevation={0} sx={{
                    width: '100%',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    backgroundColor: '#fff',
                    // position: 'absolute',
                    top: '2px',
                    left: '2px',
                    p: { xs: 2, md: 3 }
                }}>
                    {/* Back Button */}

                    {/* Header Section */}
                    <Box mb={4}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginLeft: -1 }}>
                            <IconButton
                                onClick={() => navigate(ROUTES.CAMPAIGN_BY_INFLUENCER_LIST)}
                                sx={{
                                    color: '#555',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                        color: '#4facfe'
                                    }
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                            <Typography variant="overline" sx={{
                                letterSpacing: '1px',
                                color: '#ff6b8e',
                                fontWeight: 700,
                                fontSize: '0.8rem',
                                display: 'block',
                            }}>
                                INFLYX PAY LINK
                            </Typography>
                        </Box>

                        <Typography variant="h4" sx={{
                            fontWeight: 600,
                            color: '#444',
                            mb: 0.5,
                            fontSize: { xs: '1.5rem', md: '1.75rem' }
                        }}>
                            Pay Request for ({campaign?.campaignName || 'Campaign Name'})
                        </Typography>

                        <Typography variant="body2" sx={{ color: '#bdbdbd', display: 'block', mb: 4, letterSpacing: '0.5px' }}>
                            #{campaign?.id ? campaign.id.toString().padStart(12, '404340DFF') : '#40434ODFF04'}
                        </Typography>

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
                            <Box sx={{ flex: 1, border: '1px solid #eee', borderRadius: '8px', p: 1.5, pl: 2 }}>
                                <Stack direction="row" alignItems="center" gap={0.5}>
                                    <Typography variant="caption" color="textSecondary">Send By</Typography>
                                    <Typography variant="body2" sx={{ color: '#5e9bf3', fontWeight: 500 }}>
                                        {campaign?.influencerName || 'Manjul Wadhwa'}
                                    </Typography>
                                </Stack>
                            </Box>
                            <Box sx={{ flex: 1, border: '1px solid #eee', borderRadius: '8px', p: 1.5, pl: 2 }}>
                                <Stack direction="row" alignItems="center" gap={0.5}>
                                    <Typography variant="caption" color="textSecondary">For</Typography>
                                    <Typography variant="body2" sx={{ color: '#5e9bf3', fontWeight: 600 }}>
                                        ₹{parseFloat(campaign?.totalAmount || 90000).toLocaleString()}
                                    </Typography>
                                </Stack>
                            </Box>
                            <Box sx={{ flex: 1, border: '1px solid #eee', borderRadius: '8px', p: 1.5, pl: 2 }}>
                                <Stack direction="row" alignItems="center" gap={0.5}>
                                    <Typography variant="caption" color="textSecondary">link expire</Typography>
                                    <Typography variant="body2" sx={{ color: '#5e9bf3', fontWeight: 500 }}>
                                        {campaign?.lastDateOfPayment ? getFormatedDate(campaign.lastDateOfPayment, "DD/MM/YYYY") : "20/10/2025"}
                                    </Typography>
                                </Stack>
                            </Box>
                        </Stack>
                    </Box>

                    {/* Milestones Header */}
                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography variant="caption" sx={{ color: '#757575', fontWeight: 600, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                            MILESTONE PAYMENT
                        </Typography>
                        {/* Placeholder for Dropdown Icon if needed */}
                        {/* <Typography variant="body2" color="action">v</Typography> */}
                    </Stack>

                    <Divider sx={{ borderStyle: 'none' }} />
                    {/* Note: The image doesn't strictly have a divider line, but spacing is distinct. */}

                    <Stack spacing={2}>
                        {milestones.length > 0 && milestones.map((milestone, index) => (
                            <Box key={index} sx={{
                                borderBottom: '1px solid #f0f0f0',
                                pb: 3,
                                pt: 1,
                                '&:last-child': { borderBottom: 'none' }
                            }}>
                                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={0.5}>
                                    <Stack direction="row" gap={2} alignItems="center">
                                        <Typography variant="body1" sx={{ color: '#555', fontWeight: 500 }}>
                                            {milestone.title || `Advance Payment`}
                                            {/* Using generic title from image if dynamic title is missing, 
                                            but in reality should use milestone.title or type */}
                                        </Typography>
                                        <Chip
                                            label={milestone.paymentStatus === 'completed' ? '• Completed' : '• Pending'}
                                            size="small"
                                            sx={{
                                                backgroundColor: milestone.paymentStatus === 'completed' ? '#e8f5e9' : '#fffde7',
                                                color: milestone.paymentStatus === 'completed' ? '#4caf50' : '#fbc02d',
                                                fontWeight: 700,
                                                fontSize: '0.65rem',
                                                height: '20px',
                                                border: 'none',
                                                '& .MuiChip-label': { px: 1 }
                                            }}
                                        />
                                    </Stack>
                                    <Typography variant="caption" sx={{ color: '#9e9e9e', fontSize: '0.7rem' }}>
                                        Until {milestone.lastDateOfPayment ? getFormatedDate(milestone.lastDateOfPayment, "DD/MM/YYYY") : "20/10/2025"}
                                    </Typography>
                                </Stack>

                                <Stack direction="row" justifyContent="space-between" alignItems="center" mt={1}>
                                    <div>
                                        <Typography variant="h5" sx={{ color: '#4facfe', fontWeight: 500 }}>
                                            ₹{parseFloat(milestone.amount || 0).toLocaleString()}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#9e9e9e', fontWeight: 300, fontSize: '0.7rem' }}>
                                            *Excluding 1.85% of transaction fee
                                        </Typography>
                                    </div>

                                    {milestone.paymentStatus?.toLowerCase() === 'completed' && (
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            startIcon={<Typography variant="body2" sx={{ fontWeight: 'bold' }}>✓</Typography>}
                                            sx={{
                                                backgroundColor: '#00c853',
                                                color: '#fff',
                                                textTransform: 'none',
                                                borderRadius: '6px',
                                                px: 3,
                                                py: 0.5,
                                                height: '30px',
                                                minWidth: '100px',
                                                fontWeight: 600,
                                                '&:hover': { backgroundColor: '#00e676' },
                                                boxShadow: 'none'
                                            }}
                                            onClick={() => milestone.invoiceUrl && window.open(milestone.invoiceUrl, '_blank')}

                                        >
                                            Paid
                                        </Button>
                                    )} {milestone.paymentStatus?.toLowerCase() === 'pending' && (
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            onClick={() => handlePayment(milestone.paymentLink)}
                                            disabled={!milestone.paymentLink}
                                            sx={{
                                                background: 'linear-gradient(90deg, #ff8a80 0%, #aa00ff 100%)', // Pink to Purple gradient
                                                color: '#fff',
                                                textTransform: 'none',
                                                borderRadius: '6px',
                                                px: 4,
                                                py: 0.5,
                                                height: '30px',
                                                minWidth: '100px',
                                                fontWeight: 600,
                                                boxShadow: 'none'
                                            }}
                                        >
                                            Pay
                                        </Button>
                                    )}{milestone.paymentStatus?.toLowerCase() === 'expired' && (
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            // onClick={() => handlePayment(milestone.paymentLink)}
                                            disabled={true}
                                            sx={{
                                                backgroundColor: '#ff8a80', // Pink to Purple gradient
                                                color: '#fff',
                                                textTransform: 'none',
                                                borderRadius: '6px',
                                                px: 4,
                                                py: 0.5,
                                                height: '30px',
                                                minWidth: '100px',
                                                fontWeight: 600,
                                                boxShadow: 'none'
                                            }}
                                        >
                                            Expired
                                        </Button>
                                    )}
                                </Stack>
                            </Box>
                        ))}
                    </Stack>

                    {/* Footer Section in Card */}
                    <Box mt={4} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 2 }}>
                        <Typography variant="body1" sx={{ color: '#757575', fontWeight: 500 }}>
                            Total Amount paid
                        </Typography>
                        <Typography variant="h6" sx={{ color: '#00c853', fontWeight: 600 }}>
                            ₹{totalPaid.toLocaleString()}
                        </Typography>
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
};

export default CampaignByInfluencerDetails;
